// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

import React from 'react';
import Modal from './Modal';
import Button from './Button';
import './ResetConfirmModal.css';

const ResetConfirmModal = ({ isOpen, onConfirm, onCancel }) => {
  const handleReset = () => {
    // Preserve permanent progress across resets
    const permanentProgress = localStorage.getItem('starship_permanent_progress');
    
    // Clear all localStorage
    localStorage.clear();
    
    // Restore permanent progress
    if (permanentProgress) {
      localStorage.setItem('starship_permanent_progress', permanentProgress);
    }
    
    // Hard refresh to reset all state
    window.location.reload(true);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      size="medium"
      closeOnBackdrop={true}
      closeOnEscape={true}
      showCloseButton={false}
      className="reset-confirm-modal"
    >
      <div className="reset-modal-header">
        <div className="reset-warning-icon">⚠️</div>
        <div className="reset-modal-title">KOBAYASHI MARU PROTOCOL</div>
      </div>

      <div className="reset-modal-content">
        <div className="reset-warning-message">
          Initiating no-win scenario reset. All progress will be lost.
        </div>

        <div className="reset-data-list">
          <div className="reset-data-item">
            <span className="reset-icon">⛽</span>
            <span>Antimatter reserves and tank configurations</span>
          </div>
          <div className="reset-data-item">
            <span className="reset-icon">💰</span>
            <span>Federation credits and trade records</span>
          </div>
          <div className="reset-data-item">
            <span className="reset-icon">🔧</span>
            <span>Ship modifications and upgrades</span>
          </div>
          <div className="reset-data-item">
            <span className="reset-icon">⚔️</span>
            <span>Weapons systems and tactical loadouts</span>
          </div>
          <div className="reset-data-item">
            <span className="reset-icon">📊</span>
            <span>Mission logs and exploration data</span>
          </div>
        </div>

        <div className="reset-consequence">
          Your ship will return to spacedock for complete refit. All systems will be restored to factory specifications.
        </div>

        <div className="reset-question">
          Do you accept the challenge, Captain?
        </div>
      </div>

      <div className="reset-modal-actions">
        <Button 
          variant="secondary"
          size="large"
          icon="✕"
          onClick={onCancel}
        >
          ABORT PROTOCOL
        </Button>
        <Button 
          variant="danger"
          size="large"
          icon="⚠️"
          onClick={handleReset}
        >
          ENGAGE RESET
        </Button>
      </div>
    </Modal>
  );
};

export default ResetConfirmModal;
